<div stack-layout [fullHeight]="true" gap="md" paddingVertical="md">
  <div box-layout paddingHorizontal="md">
    <button
      text-button
      size="md"
      symbolLeft="chevron_left"
      variant="ghost"
      [routerLink]="['/rma-management/summary']"
    >
      Back to Summary
    </button>
  </div>

  <div center-layout paddingHorizontal="lg">
    <div stack-layout [fullWidth]="true" gap="md">
      <div box-layout [fullWidth]="true" padding="md">
        <div stack-layout gap="sm">
          <Text role="headline-large" color="on-background-variant" display="block">
            Create RMA
          </Text>
          <Text role="body-medium" color="on-background-variant" display="block">
            Follow the steps to submit a return request.
          </Text>
        </div>
      </div>

      <div
        box-layout
        [fullWidth]="true"
        elevation="raised"
        borderRadius="xs"
        color="primary-surface"
        border="medium"
        class="rma-create-stepper"
      >
        <div class="rma-create-stepper-grid">
          <div
            class="rma-create-step"
            [class.rma-create-step--active]="currentStep() === 1"
            [class.rma-create-step--completed]="currentStep() > 1"
          >
            <div class="rma-create-step__top">
              <span class="rma-create-step__line rma-create-step__line--hidden"></span>
              <span class="rma-create-step__number">1</span>
              <span
                class="rma-create-step__line"
                [class.rma-create-step__line--active]="currentStep() > 1"
              ></span>
            </div>
            <Text role="headline-small" class="rma-create-step__label">Search &amp; Select</Text>
          </div>

          <div
            class="rma-create-step"
            [class.rma-create-step--active]="currentStep() === 2"
            [class.rma-create-step--completed]="currentStep() > 2"
          >
            <div class="rma-create-step__top">
              <span
                class="rma-create-step__line"
                [class.rma-create-step__line--active]="currentStep() > 1"
              ></span>
              <span class="rma-create-step__number">2</span>
              <span
                class="rma-create-step__line"
                [class.rma-create-step__line--active]="currentStep() > 2"
              ></span>
            </div>
            <Text role="headline-small" class="rma-create-step__label">Start Return</Text>
          </div>

          <div
            class="rma-create-step"
            [class.rma-create-step--active]="currentStep() === 3"
          >
            <div class="rma-create-step__top">
              <span
                class="rma-create-step__line"
                [class.rma-create-step__line--active]="currentStep() > 2"
              ></span>
              <span class="rma-create-step__number">3</span>
              <span class="rma-create-step__line rma-create-step__line--hidden"></span>
            </div>
            <Text role="headline-small" class="rma-create-step__label">Review &amp; Submit</Text>
          </div>
        </div>
      </div>

      @if (currentStep() === 1) {
        <div
          box-layout
          [fullWidth]="true"
          elevation="raised"
          borderRadius="xs"
          color="primary-surface"
          border="medium"
        >
          <div stack-layout gap="xs" padding="md">
            <Text role="headline-small" color="on-background-variant" display="block">
              Search &amp; Select Order
            </Text>
            <Text role="body-medium" color="on-background-variant" display="block">
              Filter orders and select one to return against.
            </Text>
          </div>

          <Divider border="medium" />

          <div box-layout padding="md">
            <div stack-layout gap="md" [fullWidth]="true">
              <div
                grid-layout
                gap="md"
                [fullWidth]="true"
                templateColumns="repeat(auto-fit, minmax(310px, 1fr))"
              >
                <div class="rma-create-channel-field">
                  <div box-layout paddingLeft="sm">
                    <Text role="headline-small">Channel</Text>
                  </div>
                  <app-select
                    [form]="searchForm"
                    controlName="channel"
                    [options]="channelOptions()"
                    [disableWhenNoOptions]="false"
                  />
                </div>

                <div>
                  <div row-layout gap="sm">
                    <div box-layout [grow]="1">
                      <div box-layout paddingLeft="sm">
                        <Text role="headline-small">Order Date From</Text>
                      </div>
                      <app-input
                        [form]="searchForm"
                        controlName="startDate"
                        type="date"
                        [max]="getTodaysDate()"
                      />
                    </div>

                    <div box-layout [grow]="1">
                      <div box-layout paddingLeft="sm">
                        <Text role="headline-small">Order Date To</Text>
                      </div>
                      <app-input
                        [form]="searchForm"
                        controlName="endDate"
                        type="date"
                        [min]="endDateMinValue()"
                        [max]="getTodaysDate()"
                      />
                    </div>
                  </div>
                </div>

                <div>
                  <div box-layout paddingLeft="sm">
                    <Text role="headline-small">Order Number</Text>
                  </div>
                  <app-input [form]="searchForm" controlName="orderNumber" />
                </div>
              </div>

              <div grid-layout [fullWidth]="true">
                <div row-layout justifyContent="end" gap="md">
                  <button text-button variant="primary" size="md" (click)="searchOrders()">
                    Search
                  </button>
                  <button text-button variant="ghost" size="md" (click)="clearFilters()">
                    Reset search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div box-layout [fullWidth]="true">
          <DataTable
            [datasource]="matchingOrdersDatasource"
            [columns]="matchingOrderColumns"
            (rowClick)="selectOrder($event)"
          >
            <div ngProjectAs="data-table-header" stack-layout gap="md">
              <div row-layout>
                <Text role="headline-small">Matching Orders</Text>
              </div>
            </div>

            <div ngProjectAs="data-table-footer" stack-layout gap="md">
              <div grid-layout>
                <div row-layout justifyContent="space-between">
                  <Text>{{ matchingOrdersDatasource.recordCount() }} Orders Found</Text>
                  <Paginator [datasource]="matchingOrdersDatasource" [initPageSize]="10" />
                  <div></div>
                </div>
              </div>
            </div>
          </DataTable>

          <div row-layout justifyContent="end" gap="md" class="rma-create-actions-row">
            <button
              text-button
              variant="ghost"
              size="md"
              [routerLink]="['/rma-management/summary']"
            >
              Cancel
            </button>
            <button
              text-button
              variant="primary"
              size="md"
              symbolRight="arrow_forward"
              [disable]="!selectedOrderId()"
              (click)="startReturn()"
            >
              Start Return
            </button>
          </div>
        </div>
      }

      <div
        stack-layout
        [fullWidth]="true"
        gap="md"
        [style.display]="currentStep() === 2 ? '' : 'none'"
      >
          @if (selectedOrder(); as order) {
            <div box-layout [fullWidth]="true" class="rma-create-selected-order-card">
              <div class="rma-create-selected-order-grid">
                <div class="rma-create-selected-order-main">
                  <span class="rma-create-selected-order-label">Selected Order</span>
                  <span class="rma-create-selected-order-value">{{ getDisplayOrderNumber(order) }}</span>
                </div>

                <div class="rma-create-selected-order-meta">
                  <span class="rma-create-selected-order-label">Customer</span>
                  <span class="rma-create-selected-order-meta-value">
                    {{ order.buyerCompanyName || '-' }}
                  </span>
                </div>

                <div class="rma-create-selected-order-meta">
                  <span class="rma-create-selected-order-label">Channel</span>
                  <span class="rma-create-selected-order-meta-value">
                    {{ order.salesChannelCode || '-' }}
                  </span>
                </div>

                <div class="rma-create-selected-order-meta">
                  <span class="rma-create-selected-order-label">DCC</span>
                  <span class="rma-create-selected-order-meta-value">{{ order.dccCode || '-' }}</span>
                </div>

                <div class="rma-create-selected-order-meta">
                  <span class="rma-create-selected-order-label">Order Date</span>
                  <span class="rma-create-selected-order-meta-value">
                    {{ getDateOnly(order.orderDate) }}
                  </span>
                </div>

                <div class="rma-create-selected-order-meta">
                  <span class="rma-create-selected-order-label">Units</span>
                  <span class="rma-create-selected-order-meta-value">{{ order.totalQty }}</span>
                </div>
              </div>
            </div>
          }

          <div box-layout [fullWidth]="true">
            <DataTable [datasource]="existingRmasDatasource" [columns]="existingRmaColumns">
              <div ngProjectAs="data-table-header" stack-layout gap="md">
                <div row-layout>
                  <Text role="headline-small">Existing RMAs on this Order</Text>
                </div>
              </div>

              <div ngProjectAs="data-table-footer" stack-layout gap="md">
                <div grid-layout>
                  <div row-layout justifyContent="space-between">
                    <Text>{{ existingRmasDatasource.recordCount() }} Existing RMAs Found</Text>
                    <Paginator [datasource]="existingRmasDatasource" [initPageSize]="10" />
                    <div></div>
                  </div>
                </div>
              </div>
            </DataTable>

            @if (existingRmasDatasource.recordCount() === 0 && existingRmaMessage()) {
              <div box-layout paddingHorizontal="sm" paddingTop="sm">
                <Text role="body-medium" color="on-background-variant">{{ existingRmaMessage() }}</Text>
              </div>
            }
          </div>

          <div class="start-return-header">
            <Text role="headline-large" color="on-background-variant" display="block">
              Start Return
            </Text>
            <div>
              <Text role="body-medium" color="on-background-variant" display="block">
                Select RMA Type, then add return lines.
              </Text>
            </div>
          </div>

          <div class="start-return-type-grid">
            <label
              class="start-return-type-option"
              [class.start-return-type-option--active]="startReturnType() === 'regular'"
            >
              <input
                type="radio"
                name="rmaType"
                [checked]="startReturnType() === 'regular'"
                (change)="setStartReturnType('regular')"
              />
              <div>
                <div class="start-return-type-title">Regular RMA</div>
                <div class="start-return-type-subtitle">
                  Standard return for defective, wrong, or damaged items.
                </div>
              </div>
            </label>

            <label
              class="start-return-type-option"
              [class.start-return-type-option--active]="startReturnType() === 'credit'"
            >
              <input
                type="radio"
                name="rmaType"
                [checked]="startReturnType() === 'credit'"
                (change)="setStartReturnType('credit')"
              />
              <div>
                <div class="start-return-type-title">Credit RMA</div>
                <div class="start-return-type-subtitle">
                  Return with credit value assignment per device IMEI.
                </div>
              </div>
            </label>
          </div>

          @for (sectionId of returnSectionIds(); track sectionId) {
            <div>
              <app-rma-return-section
                [returnNumber]="$index + 1"
                [showRemoveAction]="returnSectionIds().length > 1"
                [reasonOptions]="reasonOptions()"
                [devicesMessage]="devicesMessage()"
                [startReturnType]="startReturnType()"
                [deviceRows]="returnSectionDeviceRows()"
                [disabledImeis]="getDisabledImeisForReturn($index)"
                (addDevicesRequested)="onAddDevicesRequested()"
                (deviceSearchRequested)="onDeviceSearchRequested($event)"
                (selectedDeviceImeisChanged)="updateSelectedDeviceImeis(sectionId, $event)"
                (removeRequested)="removeReturnSection(sectionId)"
              />
            </div>
          }

          <div class="add-return-line-card">
            <div class="add-return-line-copy">
              <div class="add-return-line-title">Add another return line</div>
              <div class="add-return-line-subtitle">Multiple reason codes under one RMA.</div>
            </div>
            <button
              text-button
              variant="secondary"
              size="sm"
              symbolLeft="add"
              class="add-return-line-button"
              (click)="addReturnSection()"
            >
              Add Return
            </button>
          </div>

          <div class="start-return-footer-actions">
            <button
              text-button
              variant="ghost"
              size="md"
              symbolLeft="chevron_left"
              (click)="goToSearchAndSelect()"
            >
              Back
            </button>
            <button
              text-button
              variant="primary"
              size="md"
              symbolRight="arrow_forward"
              (click)="onReviewRma()"
            >
              Review RMA
            </button>
          </div>
        </div>

      @if (currentStep() === 3) {
        <div class="review-shell">
          <div class="review-head">
            <Text role="headline-large" color="on-background-variant" display="block" class="review-title">
              Review &amp; Submit
            </Text>
            <Text role="body-medium" color="on-background-variant" display="block" class="review-subtitle">
              Confirm all details before submitting.
            </Text>
          </div>

          <div class="review-body">
            @if (selectedOrder(); as order) {
              <div class="review-order-card">
                <div class="review-order-grid">
                  <div>
                    <div class="review-order-item-label">Order Number</div>
                    <div class="review-order-item-value">{{ getDisplayOrderNumber(order) }}</div>
                  </div>
                  <div>
                    <div class="review-order-item-label">Customer</div>
                    <div class="review-order-item-value">{{ order.buyerCompanyName || '-' }}</div>
                  </div>
                  <div>
                    <div class="review-order-item-label">Channel</div>
                    <div class="review-order-item-value">{{ order.salesChannelCode || '-' }}</div>
                  </div>
                  <div>
                    <div class="review-order-item-label">Order Date</div>
                    <div class="review-order-item-value">{{ getDateTime(order.orderDate) }}</div>
                  </div>
                  <div>
                    <div class="review-order-item-label">Qty</div>
                    <div class="review-order-item-value">{{ order.totalQty }}</div>
                  </div>
                  <div>
                    <div class="review-order-item-label">RMA Type</div>
                    <div class="review-order-item-value">
                      {{ startReturnType() === 'credit' ? 'Credit' : 'Regular' }}
                    </div>
                  </div>
                </div>
              </div>
            }

            @for (section of reviewReturnSections(); track section.returnNumber) {
              <div class="review-section-card">
                <div class="review-section-title">Return #{{ section.returnNumber }}</div>

                <div class="review-field-label">Return Reason</div>
                <div class="review-field-value">{{ section.reason }}</div>

                <div class="review-field-label">Select Device</div>
                <div class="review-table-wrap">
                  <table class="review-table">
                    <thead>
                      <tr>
                        <th>Device</th>
                        <th>IMEI</th>
                        <th>SKU</th>
                        <th>Sell Price</th>
                        @if (startReturnType() === 'credit') {
                          <th>Credit Value</th>
                        }
                      </tr>
                    </thead>
                    <tbody>
                      @for (device of section.devices; track device.id) {
                        <tr>
                          <td>{{ device.device }}</td>
                          <td>{{ device.imei }}</td>
                          <td>{{ device.sku }}</td>
                          <td>{{ device.sellPrice }}</td>
                          @if (startReturnType() === 'credit') {
                            <td>{{ device.creditValue }}</td>
                          }
                        </tr>
                      }

                      @if (startReturnType() === 'credit') {
                        <tr class="review-table-total">
                          <td colspan="4">Total</td>
                          <td>${{ section.totalCreditValue }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>

                <div class="review-comments-grid">
                  <div>
                    <div class="review-field-label">Comments</div>
                    <div class="review-field-value">{{ section.comments }}</div>
                  </div>
                  <div>
                    <div class="review-field-label">Attachments</div>
                    @if (section.attachments.length > 0) {
                      <div class="review-attachment-table">
                        <div class="review-attachment-table-header">
                          <span>File Name</span>
                          <span>Type</span>
                          <span>Size</span>
                        </div>
                        <div class="review-attachment-table-body">
                          @for (attachment of section.attachments; track attachment.name + '-' + attachment.size) {
                            <div class="review-attachment-table-row">
                              <span class="review-attachment-file-name">{{ attachment.name }}</span>
                              <span>{{ attachment.type }}</span>
                              <span>{{ attachment.size }}</span>
                            </div>
                          }
                        </div>
                      </div>
                    } @else {
                      <div class="review-field-value">None</div>
                    }
                  </div>
                </div>
              </div>
            }

            <div class="review-footer-actions">
              <button
                text-button
                variant="ghost"
                size="md"
                symbolLeft="chevron_left"
                (click)="goBackToStartReturn()"
              >
                Back &amp; Edit
              </button>

              <button
                text-button
                variant="primary"
                size="md"
                [disable]="submittingRma()"
                (click)="submitRma()"
              >
                {{ submittingRma() ? 'Submitting...' : 'Submit RMA' }}
              </button>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
</div>

<Dialog [show]="showSubmitSuccessDialog()" (showing)="showSubmitSuccessDialog.set($event)">
  <div class="submit-success-dialog">
    <div class="submit-success-icon">✓</div>
    <div class="submit-success-title">RMA Created Successfully</div>
    <div class="submit-success-subtitle">Generated RMA Number:</div>
    <div class="submit-success-rma">{{ createdRmaNumber() }}</div>

    <div class="submit-success-actions">
      <button
        text-button
        variant="ghost"
        size="md"
        class="submit-success-secondary"
        (click)="closeSubmitSuccessDialog()"
      >
        Close
      </button>
    </div>
  </div>
</Dialog>

<Dialog [show]="showExistingRmaDialog()" (showing)="showExistingRmaDialog.set($event)">
  <div class="existing-rma-dialog">
    @if (existingRmaDetailLoading()) {
      <Text role="body-medium">Loading RMA details...</Text>
    } @else if (existingRmaDetailError()) {
      <Text role="body-medium" color="error">{{ existingRmaDetailError() }}</Text>
      <div class="existing-rma-actions">
        <button text-button variant="ghost" size="md" (click)="closeExistingRmaDialog()">Close</button>
      </div>
    } @else if (existingRmaDetail(); as detail) {
      <div class="existing-rma-dialog-content">
        <div class="existing-rma-top">
          <div>
            <div class="existing-rma-meta-label">RMA Preview</div>
            <div class="existing-rma-dialog-title">{{ detail.rma_number || '-' }}</div>
          </div>
          <span [class]="getExistingRmaStatusClass(detail.status)">{{ detail.status || '-' }}</span>
        </div>

        <div class="existing-rma-meta-grid">
          <div>
            <div class="existing-rma-meta-label">Order</div>
            <div class="existing-rma-meta-value">{{ getExistingRmaOrder(detail) }}</div>
          </div>
          <div>
            <div class="existing-rma-meta-label">Type</div>
            <div class="existing-rma-meta-value">{{ detail.rma_type || '-' }}</div>
          </div>
          <div>
            <div class="existing-rma-meta-label">Channel</div>
            <div class="existing-rma-meta-value">{{ getExistingRmaChannel(detail) }}</div>
          </div>
          <div>
            <div class="existing-rma-meta-label">DCC</div>
            <div class="existing-rma-meta-value">{{ getExistingRmaDcc(detail) }}</div>
          </div>
          <div>
            <div class="existing-rma-meta-label">Warehouse</div>
            <div class="existing-rma-meta-value">{{ getExistingRmaWarehouse(detail) }}</div>
          </div>
          <div>
            <div class="existing-rma-meta-label">Units</div>
            <div class="existing-rma-meta-value">{{ detail.rma_items.length || 0 }}</div>
          </div>
          <div>
            <div class="existing-rma-meta-label">Reason</div>
            <div class="existing-rma-meta-value">{{ detail.reason || '-' }}</div>
          </div>
          @if (isCreditOnlyRma(detail.rma_type)) {
            <div>
              <div class="existing-rma-meta-label">Refund</div>
              <div class="existing-rma-meta-value">{{ formatRmaValue(detail.credit_amount) }}</div>
            </div>
          }
        </div>

        <div class="existing-rma-devices">
          <div class="existing-rma-meta-label">Devices</div>
          <div
            class="existing-rma-devices-scroll"
            [class.existing-rma-devices-scroll--limited]="existingRmaDetailDeviceRows().length > 5"
          >
            <table>
              <thead>
                <tr>
                  <th>Device</th>
                  <th>IMEI</th>
                  <th>SKU</th>
                  <th>Condition</th>
                  <th>Compliance</th>
                </tr>
              </thead>
              <tbody>
                @for (row of existingRmaDetailDeviceRows(); track row.sku + '-' + row.imei) {
                  <tr>
                    <td>{{ row.device }}</td>
                    <td>{{ row.imei }}</td>
                    <td>{{ row.sku }}</td>
                    <td>{{ row.condition }}</td>
                    <td><span [class]="getExistingRmaStatusClass(row.compliance)">{{ row.compliance }}</span></td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div class="existing-rma-activity">
          <div class="existing-rma-meta-label">Activity</div>
          <div class="existing-rma-activity-list">
            <span class="existing-rma-activity-rail" aria-hidden="true"></span>
            @for (item of getExistingRmaActivityItems(detail); track item.title + '-' + item.subtitle) {
              <div class="existing-rma-activity-item">
                <span class="existing-rma-marker" aria-hidden="true">
                  <span [class]="getExistingRmaActivityDotClass(item.variant)"></span>
                </span>
                <div>
                  <div><strong>{{ item.title }}</strong></div>
                  <div>{{ item.subtitle }}</div>
                </div>
              </div>
            }
          </div>
        </div>
      </div>

      <div class="existing-rma-actions">
        <button text-button variant="ghost" size="md" (click)="closeExistingRmaDialog()">Close</button>
      </div>
    }
  </div>
</Dialog>

<ng-template #selectionCell let-orderId="orderId">
  <div box-layout paddingHorizontal="sm" paddingVertical="sm">
    <span
      class="rma-create-selection-dot"
      [class.rma-create-selection-dot--active]="selectedOrderId() === orderId"
      aria-hidden="true"
    ></span>
  </div>
</ng-template>

<ng-template #rmaCountCell let-rmaCount="rmaCount">
  <div class="rma-count-cell" box-layout paddingHorizontal="sm" paddingVertical="sm">
    @if ((rmaCount ?? 0) > 0) {
      <span class="rma-count-badge">{{ rmaCount }}</span>
    } @else {
      <span class="rma-count-empty">-</span>
    }
  </div>
</ng-template>

<ng-template #existingRmaNumberCell let-rmaNumber="rmaNumber" let-rmaId="rmaId">
  <a
    class="existing-rma-link"
    href=""
    (click)="$event.preventDefault(); openExistingRmaDetails(rmaId)"
  >
    {{ rmaNumber }}
  </a>
</ng-template>

<ng-template #existingRmaStatusCell let-status="status">
  <span [class]="getExistingRmaStatusClass(status)">{{ status || '-' }}</span>
</ng-template>

<ng-template #rmaCountCell let-rmaCount="rmaCount">
  <div box-layout paddingHorizontal="sm" paddingVertical="sm">
    <span class="rma-count-badge">{{ rmaCount ?? 0 }}</span>
  </div>
</ng-template>

<ng-template #deviceSelectionCell let-id="id">
  <div box-layout paddingHorizontal="sm" paddingVertical="sm">
    <input
      type="checkbox"
      [checked]="isDeviceSelected(id)"
      (change)="toggleDeviceSelection(id, $any($event.target).checked)"
      aria-label="Select device"
    />
  </div>
</ng-template>

<ng-template #creditValueCell let-id="id">
  <div class="credit-value-cell" paddingVertical="sm">
    <span class="credit-value-currency">$</span>
    <input
      class="credit-values-input"
      [class.credit-values-input--error]="!!getCreditValidationMessage(id)"
      type="number"
      min="0"
      step="0.01"
      [value]="getCreditValue(id)"
      (input)="onCreditValueChange(id, $any($event.target).value)"
    />
  </div>
  @if (getCreditValidationMessage(id)) {
    <div class="credit-value-error" paddingBottom="sm">
      {{ getCreditValidationMessage(id) }}
    </div>
  }
</ng-template>

<ng-template #creditDeviceCell let-device="device">
  <div box-layout paddingHorizontal="sm" paddingVertical="sm">
    <span class="credit-device-primary">{{ device }}</span>
  </div>
</ng-template>

<ng-template #creditImeiCell let-imei="imei">
  <div box-layout paddingHorizontal="sm" paddingVertical="sm">
    <span class="credit-muted">{{ imei }}</span>
  </div>
</ng-template>

<ng-template #creditSellPriceCell let-sellPrice="sellPrice">
  <div box-layout paddingHorizontal="sm" paddingVertical="sm">
    <span class="credit-sell-price">{{ sellPrice }}</span>
  </div>
</ng-template>


